import React from 'react';
import { connect } from 'react-redux';
import { isBrowser } from 'ws-scripts/modules/environment';
import { waitForInvData } from 'wsm-srp-utilities';
import Form from '../components/Form';

class WidgetContainer extends React.Component {
	constructor(props) {
		super(props);

		if (isBrowser) {
			waitForInvData(this);
		}
	}

	render() {
		if (!isBrowser || !window.DDC.InvData) {
			return null;
		}

		return <Form />;
	}
}

const mapStateToProps = _state => ({});
const mapDispatchToProps = _dispatch => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
